import { Component, inject, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { RegisterFormCompanyComponent } from '../../main/register/register-form-company/register-form-company.component';
import { CommonModule } from '@angular/common';
import { GetCandidate } from 'src/app/models/candidate/get-candidate';
import { GetAddress } from 'src/app/models/security/register-request';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { GetUserCompany } from 'src/app/models/company/get-company';

@Component({
  selector: 'app-my-account-companies',
  templateUrl: './my-account-companies.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, CarouselComponent, RegisterFormCompanyComponent]
})
export class MyAccountCompaniesComponent implements OnInit {

  isLoading: boolean = false;
  isFound: boolean = false;
  company: GetUserCompany | null | undefined = null;
  addresses: GetAddress[] = [];

  authService = inject(AuthService);
  alertService = inject(AlertService);
  userService = inject(UserService);

  constructor() { }

  ngOnInit(): void {
    this.getCompaData();
  }

  getCompaData(): void {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getUserCompany(userId).subscribe({
      next: (res) => {
        this.company = res;
        if (res) {
          this.isFound = true;
          this.getAddresses();
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses() {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAddresses(userId).subscribe({
      next: (res) => {
        this.addresses = res;
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  savedCatcher(succeded: boolean) {
    if (succeded) {
      this.getCompaData();
    }
  }
}
